<template>
  <div class="center">
    <div class="square_titulo_vacio">
      <div class="square_titulo_valores_vacio" id="Div9" runat="server"></div>
    </div>

    <div class="q-pa-md row items-start">
      <q-card class="my-card">
        <q-card-section class="card_titulo">
          <div class="card_titulo_text">
            ¿Has olvidado tu contraseña o necesitas restablecerla?
          </div>
        </q-card-section>

        <q-card-actions align="around">
          <div class="flex-container">
            <div class="flex-item_60">
              <q-field borderless ref="UsuarioInternoModel.email">
                <q-input
                  v-model="UsuarioInternoModel.email"
                  required
                  maxlength="50"
                  dense
                  input-debounce="0"
                  class="col-12"
                  :error="$v.UsuarioInternoModel.email.$error"
                  :rules="[
                    (val) =>
                      validateEmail(val) || 'Correo electrónico no válido',
                  ]"
                  label="Introduce tu correo electrónico"
                ></q-input>
              </q-field>
            </div>
            <div class="flex-item_40"></div>
          </div>
        </q-card-actions>
        <br />
        <br />
        <q-card-section class="card_titulo">
          <div class="card_titulo_text_info">
            Te enviaremos un mensaje a tu correo electrónico con un enlace que
            te permitirá restablecer la contraseña.
          </div>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            title="enviar"
            @click="validar_email"
            class="ma-2 buttonoscuro"
            >enviar</q-btn
          >
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import { QInput, QCard, QField, QCardSection, QCardActions } from 'quasar';
import { required } from 'vuelidate/lib/validators';

export default {
  methods: {
    validateEmail (email_) {
      var re =
        // eslint-disable-next-line no-control-regex
        /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },

    comprobar_datos () {
      return this.validateEmail(this.UsuarioInternoModel.email);
    },

    validar_email () {
      this.$v.UsuarioInternoModel.$touch();
      if (this.$v.UsuarioInternoModel.$error) {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      } else if (this.comprobar_datos()) {
        let request = {
          controller: '/PasswordChangeRequest',
          filter: {},
          data: {
            mail: this.UsuarioInternoModel.email
          }
        };
        this.$store
          .dispatch('TSZ/getPasswordChangeRequest', request)
          .then((response) => {
            if (
              response.data === 'Para cambiar la contraseña contacte con el CAU'
            ) {
              this.$router.push({ name: 'login' });

              this.mostrar_mensajes(
                'Para todos los usuarios internos, el cambio de contraseña se realiza a través del CAU',
                'blue'
              );
            } else {
              this.$router.push({ name: 'login' });

              this.mostrar_mensajes(
                'Para continuar el proceso debe validar el enlace enviado a su correo electrónico',
                'blue'
              );
            }
          })
          .catch((err) => {
            this.mostrar_mensajes(err.response.data, 'red');
          });
      } else {
        this.mostrar_mensajes(
          'Deben introducirse correctamente todos los datos',
          'red'
        );
      }
    },

    mostrar_mensajes (mensaje, color = 'red', timeout = 5000) {
      this.showError(mensaje, color, timeout);
    },

    showError (text, color, timeout) {
      this.$q.notify({
        message: text,
        color: color,
        icon: 'warning',
        timeout: timeout,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  },

  validations: {
    UsuarioInternoModel: {
      email: { required }
    }
  },
  data () {
    return {
      UsuarioInternoModel: {},
      Datos_user: {
        mail: '',
        isExternal: null,
        appName: null,
        password: null,
        id: 0
      },
      Datos_profile: {
        nombre: null,
        apellidos: null,
        empresa: null,
        telefono: null,
        id: 0
      }
    };
  },

  components: {
    QInput,
    QCard,
    QField,
    QCardSection,
    QCardActions
  }
};
</script>
<style lang="scss" scoped>
$azulHover: #225eac;
$azuloscuro: #002f6c;
$azuloclaro: #878b97;

.buttonoscuro {
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
    font-weight: 600;
  }
}
</style>
